// extracted by mini-css-extract-plugin
export default {"search":"Search_search__Wncrn","input":"Search_input__PXR0c","error":"Search_error__4EP1s"};